package kz.dentalcrm.app.screens.diagnosis.edit.mvi

import kz.dentalcrm.app.core.base.ViewEvent
import kz.dentalcrm.app.data.network.response_model.diagnosis.Diagnosis

sealed interface EditDiagnosisViewEvent : ViewEvent {

    data class EditDiagnosis(
        val diagnosis: Diagnosis,
        val naming: String,
    ) : EditDiagnosisViewEvent

    data class DeleteDiagnosis(
        val diagnosis: Diagnosis
    ) : EditDiagnosisViewEvent

    data object Reset : EditDiagnosisViewEvent
}